import React from "react";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";
import ReservedBalanceHistoryItem from "./ReservedBalanceHistoryItem";

import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";

const ReservedBalanceHistoryList = ({ reservedBalanceHistory, notification, setNotification, t }) => {
  if (!reservedBalanceHistory) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (reservedBalanceHistory.length === 0) {
    return <Alert severity="warning">{t("reservedBalance.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="1440"
        size="14"
        className="reserved-balance-history"
      >
        <StyledTableHead
          scroll="auto"
          col="9"
          className="reserved-balance-history__head"
        >
          <div>
            Id
          </div>
          <div>
            {t("reservedBalance.table.paymentSystem")}
          </div>
          <div>
            {t("reservedBalance.table.currency")}
          </div>
          <div>
            {t("reservedBalance.table.amount")}
          </div>
          <div>
            {t("reservedBalance.table.processedAmount")}
          </div>
          <div>
            {t("reservedBalance.table.feeForTransferInUSDT")}
          </div>
          <div>
            {t("reservedBalance.table.status")}
          </div>
          <div>
            {t("reservedBalance.table.type")}
          </div>
          <div>
            {t("reservedBalance.table.date")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {reservedBalanceHistory.map((value, key) => (
            <ReservedBalanceHistoryItem
              value={value}
              key={key}
              t={t}
              notification={notification}
              setNotification={setNotification}
            />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default ReservedBalanceHistoryList;